import { belongsTo, attr } from '@ember-data/model';
import ShModel from 'sh-www/models/sh-model';

export default class ApplicationSellerReview extends ShModel {
  @attr('string') comment;
  @attr('number') score;
  @attr('boolean') declined;

  @attr('date') createdAt;
  @attr('date') deletedAt;
  @attr('date') updatedAt;

  @belongsTo('application', { async: false }) application;
  @belongsTo('user', { async: false, inverse: null }) reviewer;
  @belongsTo('user', { async: false, inverse: null }) reviewee;
};
